module.exports = __webpack_public_path__ + "images/sns_campaign_lp/mainvisual-title-sp@2x_c54f5f91c2d3b47317674d9577e05d3d.png";